import { render } from "./InvestigacaoDesenvolvimentoView.vue?vue&type=template&id=3de731c3&scoped=true"
import script from "./InvestigacaoDesenvolvimentoView.vue?vue&type=script&lang=js"
export * from "./InvestigacaoDesenvolvimentoView.vue?vue&type=script&lang=js"

import "./InvestigacaoDesenvolvimentoView.vue?vue&type=style&index=0&id=3de731c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de731c3"]])

export default __exports__